
import { defineComponent } from 'vue'
import { endpointFooterComposition } from '../../services';
import { panelComposition } from '@/core/modules/panel/services';

export default defineComponent({
	setup() {
		return { ...endpointFooterComposition(), ...panelComposition() }
	},
})
